module.exports = __webpack_public_path__ + "static/media/game(31).fab78d95.PNG";